import { blue20opacity10, blue50, blue60 } from '../../../colors/blue';
import { gray55, gray55opacity40, gray80 } from '../../../colors/gray';
import { neutral60opacity15 } from '../../../colors/neutral';
import { rem } from '../../../utils/rem';
export var MuiToggleButton = {
    styleOverrides: {
        root: {
            borderColor: 'transparent',
            color: gray55,
            '&:hover': {
                backgroundColor: neutral60opacity15,
            },
            '&:active': {
                backgroundColor: blue20opacity10,
                border: "".concat(rem(1), " solid ").concat(blue60),
                color: blue50,
            },
            '&:focus-visible': {
                boxShadow: "0 0 0 ".concat(rem(2), " ").concat(blue60),
            },
            '&[class*=Mui-selected]': {
                backgroundColor: blue20opacity10,
                border: "".concat(rem(1), " solid ").concat(blue60),
                color: blue50,
            },
            '&[class*=Mui-selected]:focus-visible': {
                border: "".concat(rem(1), " solid transparent"),
            },
            '&[class*=Mui-disabled]': {
                color: gray55opacity40,
                '& [class*=caption]': {
                    color: gray55opacity40,
                },
            },
            height: rem(30),
            paddingInline: rem(12),
            paddingBlock: 0,
        },
        sizeSmall: {
            fontSize: '0.775rem',
            height: rem(26),
            paddingInline: rem(12),
            paddingBlock: 0,
        },
        sizeLarge: {
            color: gray80,
            fontSize: '1.125rem',
            fontWeight: 300,
        },
    },
};
